import { useEffect, useRef } from "react";

/** Textarea that grows with its content (long descriptions / specifications). */
export default function AutoGrowTextarea({ value, ...props }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.style.height = "auto";
      el.style.height = `${el.scrollHeight}px`;
    }
  }, [value]);
  return (
    <textarea
      ref={ref}
      rows={2}
      value={value}
      {...props}
      className="w-full min-h-[32px] text-xs leading-snug px-2 py-1 rounded-sm border border-transparent bg-transparent hover:border-border focus:border-brand focus:bg-white focus:outline-none resize-y overflow-hidden transition-colors"
    />
  );
}
